import request from '@/utils/request'
// 查询积分规则信息列表分页
export function fetchList(query) {
    return request({
        url: '/fix/integral/detail',
        method: 'get',
        params: query,
    })
}
// 查询积分规则详细
export function getObj() {
    return request({
        url: '/fix/integral/current',
        method: 'get',
    })
}
// 修改积分规则
export function putObj(data) {
    return request({
        url: '/fix/integral/edit',
        method: 'post',
        data: data,
    })
}